import React, { FC, useCallback } from 'react';
import { Controller } from 'react-hook-form';
import { IFormField, IOption } from 'modules/core/types';
import { useUncontrolledInput } from 'modules/core/hooks';

import { CheckboxGroupUI, CheckBox, Input, Label } from './styles';

export interface ICheckboxGroup extends IFormField {
  options?: IOption[];
}

export const CheckboxGroup: FC<ICheckboxGroup> = ({ name, options = [] }) => {
  const { controlField, getValues } = useUncontrolledInput(name);

  const handleChange = useCallback(
    (event: any, onChange: Function) => {
      let newValues;
      const values = getValues(name);
      const changedCheckbox = event.target.value;

      if (event.target.checked) {
        newValues = [...values, changedCheckbox];
      } else {
        newValues = values.filter((v: string) => v !== changedCheckbox);
      }

      onChange(newValues);
    },
    [name, getValues],
  );

  const renderCheckboxes = useCallback(
    ({ onChange }) => (
      <CheckboxGroupUI>
        {options.map(({ title, value }) => (
          <CheckBox key={value}>
            <Input
              className="form-check-input"
              type="checkbox"
              id={title}
              value={value}
              onChange={(e) => handleChange(e, onChange)}
            />
            <Label htmlFor={title}>{title}</Label>
          </CheckBox>
        ))}
      </CheckboxGroupUI>
    ),
    [options, handleChange],
  );

  return <Controller render={renderCheckboxes} control={controlField} name={name} />;
};
